import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const maintenanceTypesApi = createApi({
  reducerPath: "maintenanceTypesApi",
  baseQuery,
  tagTypes: [],
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getMaintenanceTypes: builder.query({
      query: () => "maintenance-types",
    }),
    register: builder.mutation({
      query: (form) => ({
        url: "maintenance-types",
        method: "POST",
        body: form,
      }),
    }),
    update: builder.mutation({
      query: ({ id, form }) => ({
        url: `maintenance-types/${id}`,
        method: "PUT",
        body: form,
      }),
    }),
    delete: builder.mutation({
      query: (id) => ({
        url: `maintenance-types/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetMaintenanceTypesQuery,
  useRegisterMutation,
  useUpdateMutation,
  useDeleteMutation,
} = maintenanceTypesApi;
